var _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _rect, _path11, _ellipse, _ellipse2, _ellipse3, _path12, _path13, _path14, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path15, _path16, _circle2, _path17, _path18, _path19, _path20, _circle3, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 682.87981,
    height: 529.20554,
    viewBox: "0 0 682.87981 529.20554",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "500.134 517.115 491.071 517.114 486.758 482.152 500.136 482.153 500.134 517.115",
    fill: "#ffb6b6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M759.0138,711.9677l-27.87342-.00105v-.3525a10.84971,10.84971,0,0,1,10.84911-10.84895h.00068l5.09143-3.86263,9.4995,3.86322,2.43317.00009Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "569.198 469.407 564.906 477.39 532.07 464.632 538.406 452.849 569.198 469.407",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M836.23809,659.00029l-13.19986,24.54977-.31047-.16692a10.84971,10.84971,0,0,1-4.41811-14.693l.00032-.0006-.99116-6.31349,7.90094-6.53759,1.15225-2.143Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M741.55764,542.4041l-8,64,4,21.4567,72,31.5433,4-13c-18.40411-11.26165-38.07794-28.30535-50.4743-29.55828,0,0,26.9743-61.94172,25.9743-66.94172S741.55764,542.4041,741.55764,542.4041Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M740.17969,606.21906l-4.18522,27.02756,10.56317,55.15748h14c5.02966-18.5332,5.28906-42.8916.5-63.5Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M749.17432,464.209l6.45386-11.246,6.92946-5.55887,13-2,3.61173,2.77715,0,0a92.337,92.337,0,0,1,13.5348,67.32006l-3.54911,19.223,3.05391,14.50241a8.43853,8.43853,0,0,1-8.22268,10.17731l-32.255.13288a14.5729,14.5729,0,0,1-14.4683-16.75706Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M774.49338,502.934l-12.89107-1.84642c-4.35984,7.29027-5.90917,26.69464-5.90917,26.69464l-12.61591,29.98569a5.74941,5.74941,0,1,0,8.96309,4.31824L772.75437,527.184Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M772.44153,467.1456h0a13.73974,13.73974,0,0,1,10.85419,18.14923l-2.73562,7.7538s-1.48909,23.34672-7.16817,29.93694l-17.42639-1.57748s3.18611-11.77877.74-17.47776c-1.498-3.49018-1.41481-15.54477.06122-25.35094A13.70458,13.70458,0,0,1,772.44153,467.1456Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M747.47944,480.48888l-3.06135-12.6577c-8.38678-1.34836-26.98411,4.40223-26.98411,4.40223l-32.52589-.60779a5.74941,5.74941,0,1,0-.68992,9.92514l40.09286,6.30792Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M779.96037,465.32286l0,0a13.73974,13.73974,0,0,1-12.83581,16.80624l-8.21552.332s-22.23678,7.26724-30.46213,4.43416l-4.99157-16.77057s12.12093-1.40489,16.508-5.78842c2.68673-2.68457,13.91418-7.07371,23.56929-9.33608A13.70456,13.70456,0,0,1,779.96037,465.32286Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 507.09132,
    cy: 239.7803,
    r: 17.09366,
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M765.941,441.78564a43.92666,43.92666,0,0,0,7.4724-.5222c2.44965-.49815,7.92977-4.514,9.45745-6.93058h0a21.582,21.582,0,0,0,2.26987-6.635,19.6361,19.6361,0,0,0-3.43429-15.5885,6.20363,6.20363,0,0,0-2.50572-2.13862c-.08975-.0351-.18212-.0662-.27546-.09279a7.65415,7.65415,0,0,1-3.80758-2.35606,6.31289,6.31289,0,0,0-.633-.65143,9.42841,9.42841,0,0,0-3.93362-1.97517c-2.33835-.62582-5.72244-.00461-10.05808,1.84817a10.57969,10.57969,0,0,1-6.393.19647.59962.59962,0,0,0-.56456.19342,4.233,4.233,0,0,1-2.877,1.14683c-.655.02876-1.34226.93573-2.17293,2.11844-.18849.26847-.40843.58181-.56707.77238l-.0213-.36614-.37047.40846a5.13666,5.13666,0,0,0,2.31908,8.36869,10.01754,10.01754,0,0,0,2.01475.32107c.41235.03709.83888.07547,1.24762.14639A7.74441,7.74441,0,0,1,758.863,425.075a2.02532,2.02532,0,0,0,3.05691.98328,3.34626,3.34626,0,0,1,3.04915-.55524,2.22145,2.22145,0,0,1,.98188,1.11375,2.8949,2.8949,0,0,0,1.09848,1.28158c1.66.85587,1.77444,4.64742,1.17824,7.80814-.57469,3.04665-1.71074,5.25064-2.76258,5.35959-.80976.08377-.90235.14129-.961.2845l-.05237.1282.091.11992A3.30746,3.30746,0,0,0,765.941,441.78564Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.99754,
    y: 87.00687,
    width: 430,
    height: 127,
    fill: "#f9f9f9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M725.62031,219.88142H260.3273a1.807,1.807,0,0,1,0-3.61318h465.293a1.807,1.807,0,0,1,0,3.61318Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.69152,
    cy: 10.82345,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.26654,
    cy: 10.82345,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.84156,
    cy: 10.82345,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M703.59905,188.07993h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M703.59905,195.4643h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M703.59905,202.839h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 494.55771,
    y: 111.72282,
    width: 1.99986,
    height: 448.36258,
    transform: "translate(-225.51783 530.62326) rotate(-73.54556)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 271.37635,
    y: 334.90418,
    width: 448.36258,
    height: 1.99986,
    transform: "translate(-333.40492 -31.28962) rotate(-16.4527)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42.99754,
    y: 164.00687,
    width: 94,
    height: 91,
    rx: 45.49995,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70.59205,
    y: 278.00687,
    width: 43.78725,
    height: 9.36339,
    rx: 4.68169,
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.354,
    y: 296.73365,
    width: 88.26334,
    height: 9.36339,
    rx: 4.68169,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48.354,
    y: 315.46043,
    width: 88.26334,
    height: 9.36339,
    rx: 4.68169,
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M679.9874,499.13732H457.01732a5.304,5.304,0,0,1-5.29794-5.29794v-62.9653a5.30383,5.30383,0,0,1,5.29794-5.29774H679.9874a5.30383,5.30383,0,0,1,5.29794,5.29774v62.9653A5.304,5.304,0,0,1,679.9874,499.13732Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M679.98763,500.13738H457.01741a6.305,6.305,0,0,1-6.29785-6.29785V430.87419a6.305,6.305,0,0,1,6.29785-6.29785H679.98763a6.305,6.305,0,0,1,6.29785,6.29785v62.96534A6.305,6.305,0,0,1,679.98763,500.13738Zm-222.97022-73.561a4.303,4.303,0,0,0-4.29785,4.29785v62.96534a4.303,4.303,0,0,0,4.29785,4.29785H679.98763a4.303,4.303,0,0,0,4.29785-4.29785V430.87419a4.303,4.303,0,0,0-4.29785-4.29785Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.77761,
    cy: 261.42729,
    r: 8.59703,
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M665.70294,468.4885H471.30082a2.56,2.56,0,1,1,0-5.12H665.70294a2.56,2.56,0,1,1,0,5.12Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M644.79689,478.60441H471.30082a2.56014,2.56014,0,1,1,0-5.12029H644.79689a2.56014,2.56014,0,0,1,0,5.12029Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M679.9874,616.13732H457.01732a5.304,5.304,0,0,1-5.29794-5.29794v-62.9653a5.30383,5.30383,0,0,1,5.29794-5.29774H679.9874a5.30383,5.30383,0,0,1,5.29794,5.29774v62.9653A5.304,5.304,0,0,1,679.9874,616.13732Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M679.98763,617.13738H457.01741a6.305,6.305,0,0,1-6.29785-6.29785V547.87419a6.305,6.305,0,0,1,6.29785-6.29785H679.98763a6.305,6.305,0,0,1,6.29785,6.29785v62.96534A6.305,6.305,0,0,1,679.98763,617.13738Zm-222.97022-73.561a4.303,4.303,0,0,0-4.29785,4.29785v62.96534a4.303,4.303,0,0,0,4.29785,4.29785H679.98763a4.303,4.303,0,0,0,4.29785-4.29785V547.87419a4.303,4.303,0,0,0-4.29785-4.29785Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.77761,
    cy: 378.42729,
    r: 8.59703,
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M665.70294,585.4885H471.30082a2.56,2.56,0,1,1,0-5.12H665.70294a2.56,2.56,0,1,1,0,5.12Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M644.79689,595.60441H471.30082a2.56015,2.56015,0,1,1,0-5.12029H644.79689a2.56015,2.56015,0,0,1,0,5.12029Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M858.76526,713.5888l-.07962-.4264a50.10385,50.10385,0,0,1,10.60466-40.7702,48.61268,48.61268,0,0,1,8.93259-8.30057l.31587-.22808.13824.364c1.64845,4.34628,3.72913,8.699,4.67731,10.62566l.6399-14.38221.36515-.19366a9.50234,9.50234,0,0,1,10.59242,1.09313,9.66512,9.66512,0,0,1,3.1916,10.34918c-.49727,1.68986-.96684,3.44272-1.42124,5.13783-1.56066,5.825-3.1744,11.84829-6.30185,16.92021a30.28511,30.28511,0,0,1-22.04054,13.92489Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#f2f2f2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M941.43991,713.41277a1.18647,1.18647,0,0,1-1.19007,1.19h-448.29a1.19,1.19,0,0,1,0-2.38h448.29A1.18651,1.18651,0,0,1,941.43991,713.41277Z",
    transform: "translate(-258.56009 -185.39723)",
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/Icon7.d8505ce552ae2c85dfeb1c19208a0606.svg";
export { ForwardRef as ReactComponent };